module.exports = __webpack_public_path__ + "static/media/Zengcong Lai.449a97dc.png";